import { render, staticRenderFns } from "./susInves.vue?vue&type=template&id=4372c7e1&scoped=true&"
import script from "./susInves.vue?vue&type=script&lang=js&"
export * from "./susInves.vue?vue&type=script&lang=js&"
import style0 from "./susInves.vue?vue&type=style&index=0&id=4372c7e1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4372c7e1",
  null
  
)

export default component.exports